import React from "react";
import useTranslation from "next-translate/useTranslation";
import { setLeaguePlay, useLobby } from "../../redux/lobby";
import SegmentedControl from "../../components/ui/segmented-control";
import LeagueGamesLeft from "./MembershipInfo";
// import Link from "next/link";
// import { useGamePlay } from "@/ducks/gamePlay";
// import { useSiteData } from "@/ducks/siteData";

export default function LobbyHead() {
  const { leaguePlay } = useLobby();

  // const isDesktop = useSize();
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");

  return (
    <div className="flex justify-center mt-0 mb-4 w-full md:mb-7 md:rounded-t-none md:justify-between">
      {/* <div
        className="flex justify-center w-full md:justify-start md:bg-altgray-50"
      > */}
      <div className="flex space-x-4">
        <div className="w-[220px] md:w-[260px]">
          <SegmentedControl
            options={[lobbyT("League"), t("Practice")]}
            numbersAsOptions={true}
            startNumber={0}
            selected={leaguePlay ? 0 : 1}
            setSelected={(val: number | string) => setLeaguePlay(val === 0)}
            selectedBgColor="bg-gray-500 md:bg-gray-600"
            unselectedBgColor="bg-athens-gray-100"
            selectedTextColor="text-white"
            unselectedTextColor="text-gray-500 md:text-gray-600"
            customClassNameOuterDiv="border-2 rounded-md rounded-t-none 
            border-gray-500 md:border-gray-600  text-xs md:text-xs"
            customClassNameInnerDiv="p-1.5 "
          />
          {/* </div> */}
        </div>
      </div>

      <div className="flex space-x-4">{<LeagueGamesLeft />}</div>
    </div>
  );
}

// unselectedBgColor="bg-gray-50"
// unselectedTextColor="text-gray-600 md:text-altgray-700"
// customClassNameOuterDiv="border-2 rounded-md rounded-t-none
// border-gray-600 bg-gray-600 md:border-altgray-700 md:bg-altgray-700 text-xs md:text-xs"
// customClassNameInnerDiv="p-1.5 first:rounded-bl-[4px] last:rounded-br-[4px]"
